import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate } from 'react-router';

import { routes } from 'config/routes';
import useLocalStore from 'hooks/useLocalStore';
import { rootStore } from 'stores/RootStore';
import { ToggleStateStore } from 'stores/common';

import LogoutButton from './LogoutButton';
import LogoutModal from './LogoutModal';

const Logout: React.FC = () => {
  const { userStore } = rootStore;

  const navigate = useNavigate();

  const logoutModal = useLocalStore(() => new ToggleStateStore());

  const handleLogout = React.useCallback(async () => {
    await userStore.logout();

    logoutModal.close();

    navigate(routes.root);
  }, [userStore, logoutModal, navigate]);

  if (!userStore.isAuthorized) {
    return null;
  }

  return (
    <>
      <LogoutButton onClick={logoutModal.open} />
      <LogoutModal
        isOpen={logoutModal.opened}
        onCancel={logoutModal.close}
        onOk={handleLogout}
        isLoading={userStore.logoutLoading}
      />
    </>
  );
};

export default observer(Logout);
